import {DownloadLink} from "@bounce/shared/declarations";
import {downloadFileVariables, downloadUrl, getViewMode} from "@bounce/shared/helpers";
import axios from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = downloadFileVariables;

export const getUserFile = async (variables: Variables): Promise<DownloadLink> => {
  const result = await axiosConsumerAppInstance.get<DownloadLink>(
    `/files/download-link/${variables.accountId}/${variables.fileId}`,
    {params: {view_mode: variables.viewMode}}
  );
  if (!result.data) {
    throw new Error("Failed to fetch file download link");
  }
  return result.data;
};

export const downloadUserFiles = async (variables: Variables): Promise<void | string> => {
  const viewMode = getViewMode(variables.fileName, variables.viewMode);
  variables.viewMode = viewMode;
  const {url, file_name} = await getUserFile(variables);
  if (variables.htmlView) {
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "text/html",
      },
    });
    return response.data;
  }
  downloadUrl(url, file_name, viewMode);
};
